<div class="typo-h4-semibold mb-9">{{ eventDetails()?.title }}</div>
<div class="spaced-dot-border typo-h3-semibold py-2 uppercase tracking-wider">{{ 'schedule_event_details_title' | translate }}</div>

<div class="spaced-dot-border flex items-start justify-between gap-1 py-2">
  <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_event_details_date' | translate }}</div>
  <div class="typo-h4-medium whitespace-pre-wrap text-right text-text-primary">
    {{ eventDetails()?.date | date: 'mediumDate' }}
  </div>
</div>
<div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
  <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_event_details_time' | translate }}</div>
  <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
    {{ eventDetails()?.from?.hour ?? 0 | hourToDayPartHour }}:{{ eventDetails()?.from?.minute ?? 0 | padStart: 2 : '0'
    }}{{ eventDetails()?.from?.hour ?? 0 | hourToDayPart }} - {{ eventDetails()?.to?.hour ?? 0 | hourToDayPartHour }}:{{
      eventDetails()?.to?.minute ?? 0 | padStart: 2 : '0'
    }}{{ eventDetails()?.to?.hour ?? 0 | hourToDayPart }}
  </div>
</div>
<div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
  <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_event_details_operatory' | translate }}</div>
  <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
    {{ eventDetails()?.operatoryName }}
  </div>
</div>
<div class="spaced-dot-border flex items-start justify-between gap-8 py-2">
  <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_event_details_note' | translate }}</div>
  <div class="typo-h4-light text-right font-light text-text-primary">
    {{ eventDetails()?.notes }}
  </div>
</div>
